import colors from './colors';

export default {
  border: `1px solid ${colors.palette['gray-400']}`,
  'border-dark': `1px solid ${colors.alphas['black-alpha-20']}`,
  'border-alpha-10': `1px solid ${colors.alphas['black-alpha-10']}`,
  'border-alpha-20': `1px solid ${colors.alphas['black-alpha-20']}`,
};
